<template>
	<div class="home">
		<div class="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>地产数据</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="search" style="background-color: #fff;">
			<vs-row>
				<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="1">查询条件：</vs-col>
				<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" class="m-4 p-d flex">
					<el-date-picker
						style="width:100%"
						v-model="yearmonth"
						format="yyyy-MM"
						value-format="yyyy-MM"
						placeholder="选择月份"
            @change="changeYearDate"
						type="month">
					</el-date-picker>

				</vs-col>
				<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
					<el-cascader style="width:360px" v-model="deptid" :options="options"
					             :props="{ checkStrictly: true,value:'id',label:'name',multiple: true}"
					             class="ml-4"></el-cascader>
					<!-- <el-input v-model="deptid" placeholder="请选择部门" class="ml-4"></el-input> -->
				</vs-col>
				<vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
					<vs-button color="primary" type="filled" style="width:40%;margin-right: 20px;" @click="search">
						搜索
					</vs-button>
					<vs-button color="success" type="filled" style="width:50%" @click="handle_export">导出表格
					</vs-button>
				</vs-col>
			</vs-row>
		</div>
		<div class="tabs">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="数据总览" name="first">
					<template>
						<el-table
							id="table0"
							:header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
							:cell-style="TableRowStyle"
							v-if="tableData.length>0"
							:span-method="arraySpanMethod"
							:data="tableData"
							size="mini"
							border
							style="width: 100%">
							<el-table-column
								fixed="left"
								align="center"
								label="序号"
								width="50">
								<template slot-scope="scope">
									<p> {{ (scope.$index + 1) - (scope.$index / 3 * 2) }}</p>
								</template>
							</el-table-column>
							<el-table-column
								fixed="left"
								align="center"
								label="部门"
								width="150">
								<template slot-scope="scope">
									<p>{{ scope.row.deptName }}</p>
								</template>
							</el-table-column>
							<el-table-column
								fixed="left"
								align="center"
								label="姓名"
								width="100">
								<template slot-scope="scope">
									<p>{{ scope.row.name }}</p>
								</template>
							</el-table-column>
							<el-table-column label="顾客至上" align="center">
								<el-table-column
									align="center"
									prop="behaviors[0].finalScore"
									label="1.了解顾客需求"
									width="180">
								</el-table-column>
								<el-table-column
									align="center"
									prop="behaviors[1].finalScore"
									label="2.及时满足顾客需求"
									width="180">
								</el-table-column>
								<el-table-column
									align="center"
									prop="behaviors[2].finalScore"
									label="3.请顾客提意见">
									<template slot-scope="scope">
										<p v-if="scope.$index%3==0">{{ scope.row.behaviors[2].finalScore }}</p>
										<p v-else-if="scope.$index%3==1">{{ scope.row.dimension[0].totalScore }}</p>
										<p v-else>{{ scope.row.dimension[0].percentage }}%</p>
									</template>
								</el-table-column>
								<el-table-column
									align="center"
									prop="behaviors[3].finalScore"
									label="4.坚持提供个性化服务">
								</el-table-column>
								<el-table-column
									align="center"
									prop="behaviors[4].finalScore"
									label="5.契约精神">
								</el-table-column>
							</el-table-column>
							<el-table-column label="团队精神" align="center">
								<el-table-column
									align="center"
									prop="behaviors[5].finalScore"
									label="6.以组织利益为重"
									width="180">
								</el-table-column>
								<el-table-column
									align="center"
									prop="behaviors[6].finalScore"
									label="7.敢于担当"
									width="180">
								</el-table-column>
								<el-table-column
									align="center"
									prop="behaviors[7].finalScore"
									label="8.团队决策">
									<template slot-scope="scope">
										<p v-if="scope.$index%3==0">{{ scope.row.behaviors[7].finalScore }}</p>
										<p v-else-if="scope.$index%3==1">{{ scope.row.dimension[1].totalScore }}</p>
										<p v-else>{{ scope.row.dimension[1].percentage }}%</p>
									</template>
								</el-table-column>
								<el-table-column
									align="center"
									prop="behaviors[8].finalScore"
									label="9.主动帮助团队成员">
								</el-table-column>
								<el-table-column
									align="center"
									prop="behaviors[9].finalScore"
									label="10.积极参加团队活动">
								</el-table-column>
							</el-table-column>
							<el-table-column label="追求卓越" align="center">
								<el-table-column
									align="center"
									prop="behaviors[10].finalScore"
									label="11.坚持批判与自我批判"
									width="180">
								</el-table-column>
								<el-table-column
									align="center"
									prop="behaviors[11].finalScore"
									label="12.勇于创新"
									width="180">
								</el-table-column>
								<el-table-column
									align="center"
									prop="behaviors[12].finalScore"
									label="13.敢于挑战">
									<template slot-scope="scope">
										<p v-if="scope.$index%3==0">{{ scope.row.behaviors[12].finalScore }}</p>
										<p v-else-if="scope.$index%3==1">{{ scope.row.dimension[2].totalScore }}</p>
										<p v-else>{{ scope.row.dimension[2].percentage }}%</p>
									</template>
								</el-table-column>
								<el-table-column
									align="center"
									prop="behaviors[13].finalScore"
									label="14.长期宣传企业文化">
								</el-table-column>
								<el-table-column
									align="center"
									prop="behaviors[14].finalScore"
									label="15.自我挑战">
								</el-table-column>
							</el-table-column>
							<el-table-column label="长期坚持艰苦奋斗" align="center">
								<el-table-column
									align="center"
									prop="behaviors[15].finalScore"
									label="16.主动到异地工作"
									width="180">
								</el-table-column>
								<el-table-column
									align="center"
									prop="behaviors[6].finalScore"
									label="17.主动承担新的工作"
									width="180">
								</el-table-column>
								<el-table-column
									align="center"
									prop="behaviors[17].finalScore"
									label="18.主动加班">
									<template slot-scope="scope">
										<p v-if="scope.$index%3==0">{{ scope.row.behaviors[17].finalScore }}</p>
										<p v-else-if="scope.$index%3==1">{{ scope.row.dimension[3].totalScore }}</p>
										<p v-else>{{ scope.row.dimension[3].percentage }}%</p>
									</template>
								</el-table-column>
								<el-table-column
									align="center"
									prop="behaviors[18].finalScore"
									label="19.主动到艰苦环境工作">
								</el-table-column>
								<el-table-column
									align="center"
									prop="behaviors[19].finalScore"
									label="20.主动取消法定假日">
								</el-table-column>
							</el-table-column>

              <el-table-column label="倒扣分项" align="center">
                <el-table-column
                    align="center"
                    label="21.顾客至上"
                    prop="behaviors[20].finalScore"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    label="22.团队精神"
                    prop="behaviors[21].finalScore">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="behaviors[22].finalScore"
                    label="23.追求卓越">
                  <template slot-scope="scope">
                    <p v-if="scope.$index%3==0">{{ scope.row.behaviors[22] ? scope.row.behaviors[22].finalScore : ''}}</p>
                    <p v-else-if="scope.$index%3==1">{{ scope.row.dimension[4] ? scope.row.dimension[4].totalScore : '' }}</p>
                    <p v-else></p>
                  </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="behaviors[23].finalScore"
                    label="24.长期坚持艰苦奋斗">
                </el-table-column>
              </el-table-column>


							<el-table-column
								fixed="right"
								align="center"
								prop="total"
								label="合计"
								width="100">
							</el-table-column>
						</el-table>
					</template>
				</el-tab-pane>
        <el-tab-pane label="基层考核" name="six">
          <template>
            <el-table
                id="tableSix"
                :header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
                :cell-style="TableRowStyle"
                v-if="tableDataSix.length>0"
                :span-method="arraySpanMethodSix"
                :data="tableDataSix"
                empty-text="暂无数据"
                size="mini"
                border
                style="width: 100%">
              <el-table-column
                  fixed="left"
                  align="center"
                  label="序号"
                  width="50">
                <template slot-scope="scope">
                  <p> {{ (scope.$index + 1) - (scope.$index / 3 * 2) }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  fixed="left"
                  align="center"
                  label="部门"
                  width="150">
                <template slot-scope="scope">
                  <p>{{ scope.row.deptName }}</p>
                </template>
              </el-table-column>
              <el-table-column
                  fixed="left"
                  align="center"
                  label="姓名"
                  width="100">
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                </template>
              </el-table-column>
              <el-table-column label="顾客至上" align="center">
                <el-table-column
                    align="center"
                    prop="behaviors[0].finalScore"
                    :label="dynamicLable[0]"
                    width="180">
                </el-table-column>
              </el-table-column>
              <el-table-column label="团队精神" align="center">
                <el-table-column
                    align="center"
                    prop="behaviors[1].finalScore"
                    :label="dynamicLable[1]"
                    width="180">
                </el-table-column>
              </el-table-column>
              <el-table-column label="追求卓越" align="center">
                <el-table-column
                    align="center"
                    prop="behaviors[2].finalScore"
                    :label="dynamicLable[2]"
                    width="180">
                </el-table-column>
              </el-table-column>
              <el-table-column label="长期坚持艰苦奋斗" align="center">
                <el-table-column
                    align="center"
                    prop="behaviors[3].finalScore"
                    :label="dynamicLable[3]"
                    width="180">
                </el-table-column>
              </el-table-column>

              <el-table-column label="倒扣分项" align="center">
                <el-table-column
                    align="center"
                    prop="behaviors[4].finalScore"
                    :label="dynamicLable[4]"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="behaviors[5].finalScore"
                    :label="dynamicLable[5]"
                    >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="behaviors[6].finalScore"
                    :label="dynamicLable[6]"
                >
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="behaviors[7].finalScore"
                    :label="dynamicLable[7]"
                >
                </el-table-column>
              </el-table-column>


              <el-table-column
                  fixed="right"
                  align="center"
                  prop="total"
                  label="合计"
                  width="100">
              </el-table-column>
            </el-table>
          </template>
        </el-tab-pane>
				<el-tab-pane label="月份对比" name="second">
					<div style="display: flex;flex-direction: column;">
						<div class="vx-col w-full  mb-base">
							<el-table
								id="table1"
								:header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
								border
								:data="secend"
								style="width: 100%">
								<el-table-column
									type="index"
									align="center"
									label="序号"
									width="180">
								</el-table-column>
								<el-table-column
									prop="name"
									align="center"
									label="姓名"
									width="180">
								</el-table-column>
								<el-table-column
									prop="firstMonth"
									align="center"
									label="上月"
									:sortable="true"
									:sort-method="sortByfirstMonth">
								</el-table-column>
								<el-table-column
									prop="thisMonth"
									align="center"
									label="本月"
									:sortable="true"
									:sort-method="sortBythisMonth"
									width="180">
								</el-table-column>
								<el-table-column
									prop="growthValue"
									align="center"
									label="增长值(%)">
									<template slot-scope="scope">
										<p v-if="scope.row.growthValue>=0" style="color:red">{{ scope.row.growthValue }}<i
											class="el-icon-top"></i></p>
										<p v-if="scope.row.growthValue<0" style="color:green">
											{{ scope.row.growthValue }}<i class="el-icon-bottom"></i></p>
									</template>
								</el-table-column>
								<el-table-column
									prop="growthPercentage"
									align="center"
									label="增长率(%)">
								</el-table-column>
							</el-table>
						</div>
						<div class="vx-col w-full  mb-base" style="width: 80vw;overflow-x: auto;overflow-y: hidden;">
							<div class="flex">
								<span class="flex items-center"><div class="h-3 w-3 rounded-full mr-1 bg-primary"></div><span>本月</span></span>
								<span class="flex items-center ml-4"><div
									class="h-3 w-3 rounded-full mr-1 bg-danger"></div><span>上月</span></span>
							</div>
							<vue-apex-charts type=bar :width="secend.length*80" height=277 ref="demoone"
							                 :options="analyticsData.clientRetentionBar.chartOptions"
							                 :series="analyticsData.clientRetentionBar.series"/>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="四大分类" name="third">
					<div style="display: flex;flex-direction: column;">
						<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">全体总览：</p>
						<div class="vx-col w-full  mb-base flex"
						     style="align-items: flex-end;justify-content: space-around;">
							<div class="vx-col w-full md:w-2/5  mb-base">
								<vue-apex-charts type=donut height=345 ref="pie" class="mt-2"
								                 :options="analyticsData.sessionsByDeviceDonut.chartOptions"
								                 :series="analyticsData.sessionsByDeviceDonut.series"/>
								<ul class="mb-1">
									<li v-for="customerData in analyticsData.analyticsData"
									    :key="customerData.customerType"
									    class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
											<span class="flex items-center">
												<span class="inline-block h-3 w-3 rounded-full mr-2"
												      :class="`bg-${customerData.color}`"></span>
												<span class="font-semibold">{{ customerData.customerType }}</span>
											</span>
										<span>{{ customerData.counts }}</span>
									</li>
								</ul>
							</div>
							<div class="vx-col w-full md:w-2/5  mb-base">
								<div class="flex">
									<span class="flex items-center"><div
										class="h-3 w-3 rounded-full mr-1 bg-primary"></div><span>上月</span></span>
									<span class="flex items-center ml-4"><div
										class="h-3 w-3 rounded-full mr-1 bg-danger"></div><span>本月</span></span>
								</div>
								<vue-apex-charts type=bar height=277 ref="demotwo"
								                 :options="analyticsData.clientRetentionBar.chartOptions"
								                 :series="analyticsData.clientRetentionBar.series"/>
							</div>
						</div>
						<div class="vx-col w-full  mb-base">
							<el-table
								id="table2"
								border
								:data="third"
								style="width: 100%">
								<el-table-column
									prop="dimension"
									label="分类"
									width="180">
								</el-table-column>
								<el-table-column
									prop="firstMonth"
									label="上月得分"/>
								<el-table-column
									prop="firstAverageScore"
									label="上月平均分">
								</el-table-column>
								<el-table-column
									prop="thisMonth"
									label="本月得分"/>
								<el-table-column
									prop="thisAverageScore"
									label="本月平均分"
									width="180">
								</el-table-column>
								<el-table-column
									prop="growthValue"
									label="增长值(%)">
								</el-table-column>
								<el-table-column
									prop="growthPercentage"
									label="增长率(%)">
								</el-table-column>
							</el-table>
						</div>

						<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">管理层：</p>
						<div class="vx-col w-full  mb-base flex"
						     style="align-items: flex-end;justify-content: space-around;">
							<div class="vx-col w-full md:w-2/5  mb-base">
								<vue-apex-charts type=donut height=345 ref="pie1" class="mt-2"
								                 :options="analyticsData.sessionsByDeviceDonut.chartOptions"
								                 :series="analyticsData.sessionsByDeviceDonut.series"/>
								<ul class="mb-1">
									<li v-for="customerData in analyticsData.analyticsData"
									    :key="customerData.customerType"
									    class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
										<span class="flex items-center">
											<span class="inline-block h-3 w-3 rounded-full mr-2"
											      :class="`bg-${customerData.color}`"></span>
											<span class="font-semibold">{{ customerData.customerType }}</span>
										</span>
										<span>{{ customerData.counts }}</span>
									</li>
								</ul>
							</div>
							<div class="vx-col w-full md:w-2/5  mb-base">
								<div class="flex">
									<span class="flex items-center"><div
										class="h-3 w-3 rounded-full mr-1 bg-primary"></div><span>上月</span></span>
									<span class="flex items-center ml-4"><div
										class="h-3 w-3 rounded-full mr-1 bg-danger"></div><span>本月</span></span>
								</div>
								<vue-apex-charts type=bar height=277 ref="demotwo1"
								                 :options="analyticsData.clientRetentionBar.chartOptions"
								                 :series="analyticsData.clientRetentionBar.series"/>
							</div>
						</div>
						<div class="vx-col w-full  mb-base">
							<el-table
								id="table11"
								border
								:data="third1"
								style="width: 100%">
								<el-table-column
									prop="dimension"
									label="分类"
									width="180">
								</el-table-column>
								<el-table-column
									prop="firstMonth"
									label="上月得分"/>
								<el-table-column
									prop="firstAverageScore"
									label="上月平均分">
								</el-table-column>
								<el-table-column
									prop="thisMonth"
									label="本月得分"/>
								<el-table-column
									prop="thisAverageScore"
									label="本月平均分"
									width="180">
								</el-table-column>
								<el-table-column
									prop="growthValue"
									label="增长值(%)">
								</el-table-column>
								<el-table-column
									prop="growthPercentage"
									label="增长率(%)">
								</el-table-column>
							</el-table>
						</div>

						<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">员工层：</p>
						<div class="vx-col w-full  mb-base flex"
						     style="align-items: flex-end;justify-content: space-around;">
							<div class="vx-col w-full md:w-2/5  mb-base">
								<vue-apex-charts type=donut height=345 ref="pie2" class="mt-2"
								                 :options="analyticsData.sessionsByDeviceDonut.chartOptions"
								                 :series="analyticsData.sessionsByDeviceDonut.series"/>
								<ul class="mb-1">
									<li v-for="customerData in analyticsData.analyticsData"
									    :key="customerData.customerType"
									    class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
										<span class="flex items-center">
											<span class="inline-block h-3 w-3 rounded-full mr-2"
											      :class="`bg-${customerData.color}`"></span>
											<span class="font-semibold">{{ customerData.customerType }}</span>
										</span>
										<span>{{ customerData.counts }}</span>
									</li>
								</ul>
							</div>
							<div class="vx-col w-full md:w-2/5  mb-base">
								<div class="flex">
									<span class="flex items-center"><div
										class="h-3 w-3 rounded-full mr-1 bg-primary"></div><span>上月</span></span>
									<span class="flex items-center ml-4"><div
										class="h-3 w-3 rounded-full mr-1 bg-danger"></div><span>本月</span></span>
								</div>
								<vue-apex-charts type=bar height=277 ref="demotwo2"
								                 :options="analyticsData.clientRetentionBar.chartOptions"
								                 :series="analyticsData.clientRetentionBar.series"/>
							</div>
						</div>
						<div class="vx-col w-full  mb-base">
							<el-table
								id="table22"
								border
								:data="third2"
								style="width: 100%">
								<el-table-column
									prop="dimension"
									label="分类"
									width="180">
								</el-table-column>
								<el-table-column
									prop="firstMonth"
									label="上月得分"/>
								<el-table-column
									prop="firstAverageScore"
									label="上月平均分">
								</el-table-column>
								<el-table-column
									prop="thisMonth"
									label="本月得分"/>
								<el-table-column
									prop="thisAverageScore"
									label="本月平均分"
									width="180">
								</el-table-column>
								<el-table-column
									prop="growthValue"
									label="增长值(%)">
								</el-table-column>
								<el-table-column
									prop="growthPercentage"
									label="增长率(%)">
								</el-table-column>
							</el-table>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="20项指标" name="fourth">
					<div style="display: flex;flex-direction: column;">
						<div class="vx-col w-full  mb-base">
							<el-table
								id="table3"
								:header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
								border
								:data="thoused"
								style="width: 100%">
								<el-table-column
									prop="behaviors"
									label="指标项"
									width="180">
								</el-table-column>
								<el-table-column
									prop="firstMonthAverageScore"
									label="上月平均分">
								</el-table-column>
								<el-table-column
									prop="thisMonthAverageScore"
									label="本月平均分">
								</el-table-column>
								<el-table-column
									prop="thisMonth"
									:sortable="true"
									:sort-method="sortBythisall"
									label="本月总得分"
									width="180">
								</el-table-column>
								<el-table-column
									prop="growthValue"
									:sortable="true"
									:sort-method="sortByfirstall"
									label="增长值(%)">
									<template slot-scope="scope">
										<p v-if="scope.row.growthValue>=0" style="color:red">{{ scope.row.growthValue }}<i
											class="el-icon-top"></i></p>
										<p v-if="scope.row.growthValue<0" style="color:green">
											{{ scope.row.growthValue }}<i class="el-icon-bottom"></i></p>
									</template>
								</el-table-column>
								<el-table-column
									prop="growthPercentage"
									label="增长率(%)">
								</el-table-column>
							</el-table>
						</div>
						<div class="vx-col w-full  mb-base">
							<div class="flex">
								<span class="flex items-center"><div class="h-3 w-3 rounded-full mr-1 bg-primary"></div><span>上月</span></span>
								<span class="flex items-center ml-4"><div
									class="h-3 w-3 rounded-full mr-1 bg-danger"></div><span>本月</span></span>
							</div>
							<vue-apex-charts type=bar height=377 ref="demothree"
							                 :options="analyticsData.clientRetentionBar.chartOptions"
							                 :series="analyticsData.clientRetentionBar.series"/>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="结果分析" name="five">
					<div style="display: flex;flex-direction: column;">
						<div class="vx-col w-full  mb-base">
							<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">管理层：</p>
							<el-table
								id="table4"
								:header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
								border
								:data="five.management"
								style="width: 100%">
								<el-table-column
									type="index"
									label="序号"
									width="180">
								</el-table-column>
								<el-table-column
									prop="deptName"
									label="部门"
									width="180">
								</el-table-column>
								<el-table-column
									prop="name"
									label="姓名">
								</el-table-column>
								<el-table-column
									prop="customerFirst"
									label="顾客至上">
								</el-table-column>
								<el-table-column
									prop="teamSpirit"
									label="团队精神">
								</el-table-column>
								<el-table-column
									prop="pursueExcellence"
									label="追求卓越">
								</el-table-column>
								<el-table-column
									prop="persistInhardWorkForalongTime"
									label="长期坚持艰苦奋斗">
								</el-table-column>
								<el-table-column
									prop="score"
									label="得分">
									<template slot-scope="scope">
										<p style="color: red;">{{ scope.row.score }}</p>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="vx-col w-full  mb-base">
							<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">员工层：</p>
							<el-table
								id="table5"
								:header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
								border
								:data="five.staff"
								style="width: 100%">
								<el-table-column
									type="index"
									label="序号"
									width="180">
								</el-table-column>
								<el-table-column
									prop="deptName"
									label="部门"
									width="180">
								</el-table-column>
								<el-table-column
									prop="name"
									label="姓名">
								</el-table-column>
								<el-table-column
									prop="customerFirst"
									label="顾客至上">
								</el-table-column>
								<el-table-column
									prop="teamSpirit"
									label="团队精神">
								</el-table-column>
								<el-table-column
									prop="pursueExcellence"
									label="追求卓越">
								</el-table-column>
								<el-table-column
									prop="persistInhardWorkForalongTime"
									label="长期坚持艰苦奋斗">
								</el-table-column>
								<el-table-column
									prop="score"
									label="得分">
									<template slot-scope="scope">
										<p style="color: red;">{{ scope.row.score }}</p>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="vx-col w-full  mb-base">
							<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">
								两极分化(总览)：</p>
							<el-table
								id="table6"
								:header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
								border
								:data="five.rankingRepresentative"
								style="width: 100%">
								<el-table-column
									prop="dimension"
									label="类别"
									width="180">
								</el-table-column>
								<el-table-column
									prop="theAverageScore"
									label="平均得分"
									width="180">
								</el-table-column>
								<el-table-column
									prop="highestScore"
									label="最高得分">
									<template slot-scope="scope">
										<p>{{ scope.row.highestScore }}({{ scope.row.highestScoreName }})</p>
									</template>
								</el-table-column>
								<el-table-column
									prop="minimumScore"
									label="最低得分">
									<template slot-scope="scope">
										<p>{{ scope.row.minimumScore }}({{ scope.row.minimumScoreName }})</p>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="vx-col w-full  mb-base">
							<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">
								两极分化(管理层)：</p>
							<el-table
								id="table7"
								:header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
								border
								:data="five.rankingRepresentativeManagement"
								style="width: 100%">
								<el-table-column
									prop="dimension"
									label="类别"
									width="180">
								</el-table-column>
								<el-table-column
									prop="theAverageScore"
									label="平均得分"
									width="180">
								</el-table-column>
								<el-table-column
									prop="highestScore"
									label="最高得分">
									<template slot-scope="scope">
										<p>{{ scope.row.highestScore }}({{ scope.row.highestScoreName }})</p>
									</template>
								</el-table-column>
								<el-table-column
									prop="minimumScore"
									label="最低得分">
									<template slot-scope="scope">
										<p>{{ scope.row.minimumScore }}({{ scope.row.minimumScoreName }})</p>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="vx-col w-full  mb-base">
							<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">
								两极分化(员工层)：</p>
							<el-table
								id="table8"
								:header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
								border
								:data="five.rankingRepresentativeStaff"
								style="width: 100%">
								<el-table-column
									prop="dimension"
									label="类别"
									width="180">
								</el-table-column>
								<el-table-column
									prop="theAverageScore"
									label="平均得分"
									width="180">
								</el-table-column>
								<el-table-column
									prop="highestScore"
									label="最高得分">
									<template slot-scope="scope">
										<p>{{ scope.row.highestScore }}({{ scope.row.highestScoreName }})</p>
									</template>
								</el-table-column>
								<el-table-column
									prop="minimumScore"
									label="最低得分">
									<template slot-scope="scope">
										<p>{{ scope.row.minimumScore }}({{ scope.row.minimumScoreName }})</p>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div class="vx-col w-full  mb-base">
							<div style="display: flex;align-items: center;line-height: 60px;">
								<p style="color:#000000;font-size: 15px;font-weight: 600;line-height: 30px;">
									考核分段：</p>
								<el-select v-model="grade" placeholder="请选择分段">
									<el-option label="70-80划分" :value="gradarr[0]"></el-option>
									<el-option label="75-85划分" :value="gradarr[1]"></el-option>
									<el-option label="80-90划分" :value="gradarr[2]"></el-option>
								</el-select>
							</div>

							<el-table
								id="table9"
								:header-cell-style="{background:'#7367F0',color:'#ffffff',fontSize:'14px'}"
								v-if="five.assessmentSituation&&five.assessmentSituation.length>0"
								:data="five.assessmentSituation"
								border
								style="width: 100%">
								<el-table-column label="企业文化考核情况" align="center">
									<el-table-column
										fixed="left"
										align="center"
										label="类别"
										width="120">
										<template slot-scope="scope">
											<p>{{ scope.row.category }}</p>
										</template>
									</el-table-column>
									<el-table-column
										fixed="left"
										align="center"
										label="考核人数"
										width="100">
										<template slot-scope="scope">
											<p>{{ scope.row.numberOfPeople }}</p>
										</template>
									</el-table-column>
									<el-table-column
										fixed="left"
										align="center"
										label="平均分"
										width="100">
										<template slot-scope="scope">
											<p>{{ scope.row.theAverageScore }}</p>
										</template>
									</el-table-column>
									<el-table-column :label="JSON.parse(grade).lowestScore+'分(含)以下'" align="center">
										<el-table-column
											align="center"
											prop="scoreData[0].numberOfPeople"
											label="人数">
										</el-table-column>
										<el-table-column
											align="center"
											prop="scoreData[0].proportion"
											label="占比">
											<template slot-scope="scope">
												<p>{{ scope.row.scoreData[0].proportion }}%</p>
											</template>
										</el-table-column>
										<el-table-column
											align="center"
											prop="scoreData[0].environmentFirstMonth"
											label="环比上月">
											<template slot-scope="scope">
												<p>{{ scope.row.scoreData[0].environmentFirstMonth }}%</p>
											</template>
										</el-table-column>
									</el-table-column>
									<el-table-column
										:label="JSON.parse(grade).startPoints+'-'+JSON.parse(grade).endPoints+'分'"
										align="center">
										<el-table-column
											align="center"
											prop="scoreData[1].numberOfPeople"
											label="人数">
										</el-table-column>
										<el-table-column
											align="center"
											prop="scoreData[1].proportion"
											label="占比">
											<template slot-scope="scope">
												<p>{{ scope.row.scoreData[1].proportion }}%</p>
											</template>
										</el-table-column>
										<el-table-column
											align="center"
											prop="scoreData[1].environmentFirstMonth"
											label="环比上月">
											<template slot-scope="scope">
												<p>{{ scope.row.scoreData[1].environmentFirstMonth }}%</p>
											</template>
										</el-table-column>
									</el-table-column>
									<el-table-column :label="JSON.parse(grade).highestScore+'(含)-100分'"
									                 align="center">
										<el-table-column
											align="center"
											prop="scoreData[2].numberOfPeople"
											label="人数">
										</el-table-column>
										<el-table-column
											align="center"
											prop="scoreData[2].proportion"
											label="占比">
											<template slot-scope="scope">
												<p>{{ scope.row.scoreData[2].proportion }}%</p>
											</template>
										</el-table-column>
										<el-table-column
											align="center"
											prop="scoreData[2].environmentFirstMonth"
											label="环比上月">
											<template slot-scope="scope">
												<p>{{ scope.row.scoreData[2].environmentFirstMonth }}%</p>
											</template>
										</el-table-column>
									</el-table-column>
								</el-table-column>
							</el-table>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>
<script>
import FileSaver from "file-saver";
import XLSX from "xlsx";

import analyticsData from './ui-elements/card/analyticsData.js'
import VueApexCharts from 'vue-apexcharts'

export default {
	data() {
		return {
			analyticsData: analyticsData,
			activeName: "first",
			tableData: [],
      tableDataSix: [],
			secend: [],
			third: [],
			third1: [],
			third2: [],
			thoused: [],
			five: [],
			yearmonth: '',   //月份
      delScoreFlag: false,
			deptid: [],      //部门
			options: [],     //部门列表
			grade: '{"lowestScore":80,"startPoints":80,"endPoints":90,"highestScore":90}',
			gradarr: [
				'{"lowestScore":70,"startPoints":70,"endPoints":80,"highestScore":80}',
				'{"lowestScore":75,"startPoints":75,"endPoints":85,"highestScore":85}',
				'{"lowestScore":80,"startPoints":80,"endPoints":90,"highestScore":90}'
			],
      dynamicLable: []
		}
	},
	created() {
		this.yearmonth = this.getNowFormatDate();
	},
	mounted() {
		this.getoptions();
		this.getall();
	},
	components: {
		VueApexCharts,
	},
	watch: {
		grade(newval, oldval) {
			console.log(newval);
			this.getfive();
		}
	},
	methods: {
    changeYearDate() {
      let date = new Date(this.yearmonth + '-01');
      let updateDate = new Date('2024-08-01');
      this.delScoreFlag = updateDate <= date;
      console.info(this.yearmonth, this.delScoreFlag);
    },
		// 导出
		handle_export() {
			let table = document.querySelector("#table0").cloneNode(true);
			table.removeChild(table.querySelector(".el-table__fixed-right"));
			table.removeChild(table.querySelector(".el-table__fixed"));
			var xlsxParam = {
				raw: true
			}; //转换成excel时，使用原始的格式，这样导出的时候数字过长不会变成科学计数法
			let workbook = XLSX.utils.book_new();
			let ws0 = XLSX.utils.table_to_sheet(table, xlsxParam);
			XLSX.utils.book_append_sheet(workbook, ws0, '数据总览');
			let ws1 = XLSX.utils.table_to_sheet(document.querySelector('#table1'), xlsxParam);

      if (this.tableDataSix.length > 0) {
        let tableSix = XLSX.utils.table_to_sheet(document.querySelector('#tableSix'), xlsxParam);
        XLSX.utils.book_append_sheet(workbook, tableSix, '基层考核');
      }
			// 这里可以添加多个sheet页
			XLSX.utils.book_append_sheet(workbook, ws1, '月份对比');
			let ws2 = XLSX.utils.table_to_sheet(document.querySelector('#table2'), xlsxParam);
			XLSX.utils.book_append_sheet(workbook, ws2, '四大分类');
			let ws3 = XLSX.utils.table_to_sheet(document.querySelector('#table3'), xlsxParam);
			XLSX.utils.book_append_sheet(workbook, ws3, '20项指标');
			let ws4 = XLSX.utils.table_to_sheet(document.querySelector('#table4'), xlsxParam);
			XLSX.utils.book_append_sheet(workbook, ws4, '结果分析管理层');
			let ws5 = XLSX.utils.table_to_sheet(document.querySelector('#table5'), xlsxParam);
			XLSX.utils.book_append_sheet(workbook, ws5, '结果分析员工层');
			let ws6 = XLSX.utils.table_to_sheet(document.querySelector('#table6'), xlsxParam);
			XLSX.utils.book_append_sheet(workbook, ws6, '最高与最低(总览)');
			let ws8 = XLSX.utils.table_to_sheet(document.querySelector('#table7'), xlsxParam);
			XLSX.utils.book_append_sheet(workbook, ws8, '最高与最低(管理层)');
			let ws9 = XLSX.utils.table_to_sheet(document.querySelector('#table8'), xlsxParam);

			XLSX.utils.book_append_sheet(workbook, ws9, '最高与最低(员工层)');
      if (this.five.assessmentSituation && this.five.assessmentSituation.length > 0) {
        let ws7 = XLSX.utils.table_to_sheet(document.querySelector('#table9'), xlsxParam);
        XLSX.utils.book_append_sheet(workbook, ws7, '考核分段');
      }

			let wbout = XLSX.write(workbook, {
				bookType: 'xlsx',
				bookSST: true,
				type: 'array'
			});
			try {
				FileSaver.saveAs(
					new Blob([wbout], {
						type: 'application/octet-stream;charset=utf-8"'
					}), '统计分析.xlsx');
			} catch (e) {
				if (typeof console !== 'undefined') console.log(e);
			}
			return wbout;
		},
		//定义导出Excel表格事件
		exportExcel() {
			var xlsxParam = {raw: true};
			/* 从表生成工作簿对象 */
			var wb = XLSX.utils.table_to_book(
				document.querySelector("#outtable"),
				xlsxParam
			);
			/* 获取二进制字符串作为输出 */
			var wbout = XLSX.write(wb, {
				bookType: "xlsx",
				bookSST: true,
				type: "array",
			});
			try {
				FileSaver.saveAs(
					//Blob 对象表示一个不可变、原始数据的类文件对象。
					//Blob 表示的不一定是JavaScript原生格式的数据。
					//File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
					//返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
					new Blob([wbout], {type: "application/octet-stream"}),
					//设置导出文件名称
					"sheetjs.xlsx"
				);
			} catch (e) {
				if (typeof console !== "undefined") console.log(e, wbout);
			}
			return wbout;
		},

		getoptions() {	//获取部门列表
			const that = this;
			this.$api.getmember({}).then(function (response) {
				console.log("组织架构：", response);
				if (response.code == 0) {
					that.data = JSON.parse(JSON.stringify(response.data));
					that.options = that.removeEmptyChildren(response.data);
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		removeEmptyChildren(node) {   //杀生
			var that = this;
			node.forEach(item => {
				if ('children' in item && item.children.length === 0) {
					delete item.children
				} else if ('children' in item && item.children.length) {
					that.removeEmptyChildren(item.children)
				}
			})
			return node;
		},
		sortBythisMonth(obj1, obj2) {	//本月排序
			console.log("排序啦", obj1, obj2);
			let val1 = obj1.thisMonth;
			let val2 = obj2.thisMonth;
			return val1 - val2

		},
		sortByfirstMonth(obj1, obj2) {	//上月排序
			console.log("排序啦", obj1, obj2);
			let val1 = obj1.firstMonth;
			let val2 = obj2.firstMonth;
			return val1 - val2

		},
		sortBythisall(obj1, obj2) {	//20项本月排序
			console.log("排序啦", obj1, obj2);
			let val1 = obj1.thisMonth;
			let val2 = obj2.thisMonth;
			return val1 - val2

		},
		sortByfirstall(obj1, obj2) {	//20项上月排序
			console.log("排序啦", obj1, obj2);
			let val1 = obj1.firstMonth;
			let val2 = obj2.firstMonth;
			return val1 - val2

		},
		TableRowStyle({row, column, rowIndex, columnIndex}) {
			if (columnIndex != 0 && columnIndex != 1 && columnIndex != 23) {
				if (rowIndex % 3 == 0) {
					return {color: "red", fontSize: "18px"};
				} else if (rowIndex % 3 == 1) {
					return {color: "#5ECDF5", fontSize: "18px"};
				} else if (rowIndex % 3 == 2) {
					return {color: "#000000", fontSize: "18px"};
				}
			} else {
				return {color: "#000000", fontSize: "18px"};
			}
		},
		arraySpanMethod({row, column, rowIndex, columnIndex}) {  //合并行与列
			if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 27) {
				if (rowIndex % 3 === 0) {
					return {
						rowspan: 3,
						colspan: 1
					};
				} else {
					return {
						rowspan: 0,
						colspan: 0
					};
				}
			} else if (rowIndex % 3 === 1 || rowIndex % 3 === 2) {
				if (columnIndex === 5 ||  columnIndex === 10 || columnIndex === 15 || columnIndex === 20) {
					return {
						rowspan: 1,
						colspan: 5
					};
				} else if (columnIndex === 25) {
          return {
            rowspan: 1,
            colspan: 4
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
			}
		},
    arraySpanMethodSix({row, column, rowIndex, columnIndex}) {  //合并行与列
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 11) {
        if (rowIndex % 3 === 0) {
          return {
            rowspan: 3,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      } else if (rowIndex % 3 === 1 || rowIndex % 3 === 2) {
        console.info("columnIndex", rowIndex, columnIndex);
        if (columnIndex === 11) {
          return {
            rowspan: 1,
            colspan: 4
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
		handleClick() {
			console.log("切换了", this.activeName);
			if (this.activeName == "first") {
				this.getall()
			} else if (this.activeName == "second") {
				this.getsecend()
			} else if (this.activeName == "third") {
				this.getthird()
			} else if (this.activeName == "fourth") {
				this.getthoused()
			} else if (this.activeName == "five") {
				this.getfive()
			} else if (this.activeName == "six") {
        this.getSix()
      }
		},
		search() {
			if (this.activeName == "first") {
				this.getall()
			} else if (this.activeName == "second") {
				this.getsecend()
			} else if (this.activeName == "third") {
				this.getthird()
			} else if (this.activeName == "fourth") {
				this.getthoused()
			} else if (this.activeName == "five") {
				this.getfive()
			} else if (this.activeName == "six") {
        this.getSix()
      }
		},
		formatDeptId() {
			if (this.deptid && this.deptid.length) {
				return this.deptid.map(value => {
					return value[value.length - 1]
				}).join()
			}
			return ''
		},
		getfive() {
			const that = this;
			const g = JSON.parse(that.grade);
			// const k = {assessTime: that.yearmonth, deptId: that.deptid[that.deptid.length - 1]};
			const k = {assessTime: that.yearmonth, deptIds: that.formatDeptId()};
			const obj = {...g, ...k};
			console.log("对象", obj);
			this.$api.statisticsfive(obj).then(function (response) {
				if (response.code == 0) {
					that.five = response.data;
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		getthoused() {
			const that = this;
			this.$api.statisticsthoused({
				assessTime: that.yearmonth,
				deptIds: that.formatDeptId()
				// deptId: that.deptid[that.deptid.length - 1]
			}).then(function (response) {
				if (response.code == 0) {
					that.thoused = response.data;
					var name = [];
					var thisMonth = [];
					var firstMonth = [];
					response.data.forEach(item => {
						name.push(item.behaviors);
						thisMonth.push(item.thisMonth);
						firstMonth.push(item.firstMonth);
					})
					that.$refs.demothree.updateOptions({
						series: [{name: '上月', data: firstMonth}, {name: '本月', data: thisMonth,}],
						xaxis: {categories: name}
					})
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		getthird() {     //四大分类
			const that = this;
			this.$api.statisticsthird({
				assessTime: that.yearmonth,
				deptIds: that.formatDeptId()
				// deptId: that.deptid[that.deptid.length - 1]
			}).then(function (response) {
				if (response.code == 0) {
					that.third = response.data.all;
					that.third1 = response.data.management;
					that.third2 = response.data.staff;
					var name = [], name1 = [], name2 = [];
					var thisAverageScore = [], thisAverageScore1 = [], thisAverageScore2 = [];
					var firstAverageScore = [], firstAverageScore1 = [], firstAverageScore2 = [];
					response.data.all.forEach(item => {
						name.push(item.dimension);
						thisAverageScore.push(Number(item.thisAverageScore));
						firstAverageScore.push(item.firstAverageScore);
					})
					response.data.management.forEach(item => {  //管理
						name1.push(item.dimension);
						thisAverageScore1.push(Number(item.thisAverageScore));
						firstAverageScore1.push(item.firstAverageScore);
					})
					response.data.staff.forEach(item => {    //员工
						name2.push(item.dimension);
						thisAverageScore2.push(Number(item.thisAverageScore));
						firstAverageScore2.push(item.firstAverageScore);
					})
					that.$refs.demotwo.updateOptions({   //柱状图
						series: [{name: '上月', data: firstAverageScore}, {name: '本月', data: thisAverageScore,}],
						xaxis: {categories: name}
					})
					that.$refs.demotwo1.updateOptions({   //柱状图
						series: [{name1: '上月', data: firstAverageScore1}, {name: '本月', data: thisAverageScore1,}],
						xaxis: {categories: name1}
					})
					that.$refs.demotwo2.updateOptions({   //柱状图
						series: [{name2: '上月', data: firstAverageScore2}, {name: '本月', data: thisAverageScore2,}],
						xaxis: {categories: name2}
					})
					that.$refs.pie.updateOptions({   //环形图
						series: thisAverageScore,
						labels: name
					})
					that.$refs.pie1.updateOptions({   //环形图
						series: thisAverageScore1,
						labels: name1
					})
					that.$refs.pie2.updateOptions({   //环形图
						series: thisAverageScore2,
						labels: name2
					})
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		getsecend() {
			const that = this;
			this.$api.statisticssecend({
				assessTime: that.yearmonth,
				deptIds: that.formatDeptId()
				// deptId: that.deptid[that.deptid.length - 1]
			}).then(function (response) {
				if (response.code == 0) {
					that.secend = response.data;
					var name = [];
					var thisMonth = [];
					var firstMonth = [];
					response.data.forEach(item => {
						name.push(item.name);
						thisMonth.push(item.thisMonth);
						firstMonth.push(item.firstMonth);
					})
					that.$refs.demoone.updateOptions({
						series: [{name: '上月', data: firstMonth}, {name: '本月', data: thisMonth,}],
						xaxis: {categories: name}
					})
					that.analyticsData.clientRetentionBar.chartOptions.xaxis.categories = name;
					that.analyticsData.clientRetentionBar.series = [
						{name: '本月', data: thisMonth,},
						{name: '上月', data: firstMonth,}];
					console.log("图标", that.analyticsData.clientRetentionBar);
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
		getall() {
			const that = this;
			this.$api.statisticsfirst({
				assessTime: that.yearmonth,
				deptIds: that.formatDeptId()
				// deptId: that.deptid[that.deptid.length - 1]
			}).then(function (response) {
				console.log("提交结果：", response);
				if (response.code == 0) {
					that.tableData = response.data;
					var arr = [];
					response.data.forEach(item => {
						// if(item.behaviors.length<20){
						//  console.log("111",item.name);
						// }

						var a = [item, item, item];
						arr.push.apply(arr, a);
					})
					that.tableData = arr;
				} else {
					that.$vs.notify({
						title: "提示",
						color: 'warning',
						text: response.message,
						position: 'top-center'
					});
				}
			})
		},
    getSix() {
      const that = this;
      this.$api.statisticsfirst({
        assessTime: that.yearmonth,
        deptIds: that.formatDeptId(),
        commonUser: 1
      }).then(function (response) {
        console.log("提交结果：", response);
        if (response.code == 0) {
          that.tableDataSix = response.data;
          var arr = [];
          response.data.forEach(item => {
            var a = [item, item, item];
            arr.push.apply(arr, a);
          })
          that.tableDataSix = arr;
          if (response.data.length > 0 && response.data[0].behaviors.length > 0) {
            that.dynamicLable = response.data[0].behaviors.map(item => item.behaviors.slice(0, 12));
          }
        } else {
          that.$vs.notify({
            title: "提示",
            color: 'warning',
            text: response.message,
            position: 'top-center'
          });
        }
      })
    },
		getNowFormatDate() {
			var date = new Date();
			var seperator1 = "-";
			var year = date.getFullYear();
			var month = date.getMonth() + 1;
			var strDate = date.getDate();
			if (month >= 1 && month <= 9) {
				month = "0" + month;
			}
			if (strDate >= 0 && strDate <= 9) {
				strDate = "0" + strDate;
			}
			var currentdate = year + seperator1 + month;
			var lastmonth = this.getPreMonth(currentdate)
			return lastmonth;
		},
		/**
		 * 获取上一个月
		 * @date 格式为yyyy-mm-dd的日期，如：2014-01
		 */
		getPreMonth(date) {
			var arr = date.split('-');
			var year = arr[0]; //获取当前日期的年份
			var month = arr[1]; //获取当前日期的月份
			var days = new Date(year, month, 0);
			days = days.getDate(); //获取当前日期中月的天数
			var year2 = year;
			var month2 = parseInt(month) - 1;
			if (month2 == 0) {
				year2 = parseInt(year2) - 1;
				month2 = 12;
			}
			if (month2 < 10) {
				month2 = '0' + month2;
			}
			var t2 = year2 + '-' + month2;
			return t2;
		},

	}
}
</script>
<style type="text/css">
.el-cascader-menu__wrap {
  height: 340px;
}

.home .head {
	height: 50px;
	display: flex;
	align-items: center;
	background: #ffffff;
	padding: 20px;
}

.home .tabs {
	margin: 20px 30px;
	background: #ffffff;
	padding: 20px;
}

.home .el-table {
	border: 1px solid #000000 !important;
	border-left: 1px solid #000000 !important;
}

.home .el-table td,
.home .el-table th {
	border-bottom: 1px solid #000000 !important;
	border-right: 1px solid #000000 !important;
}
</style>
